const API_BASE = process.env.REACT_APP_FUNCTIONS_BASE_URL;
const DEBUG_LOGS = process.env.REACT_APP_DEBUG_LOGS === "true";

async function postJson(path, payload, { timeoutMs = 20000 } = {}) {
  if (!API_BASE) {
    throw new Error("REACT_APP_FUNCTIONS_BASE_URL is not set");
  }
  const url = `${API_BASE}${path}`;
  if (DEBUG_LOGS) {
    // eslint-disable-next-line no-console
    console.log("[contactService] request", {url, payload});
  }
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  let res;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
  } catch (err) {
    if (err?.name === "AbortError") {
      throw new Error("Request timed out. Please try again.");
    }
    if (err instanceof TypeError) {
      throw new Error("Unable to reach the server right now. Please try again shortly.");
    }
    throw err;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!res.ok) {
    const text = await res.text();
    if (DEBUG_LOGS) {
      // eslint-disable-next-line no-console
      console.error("[contactService] error response", {
        url,
        status: res.status,
        body: text,
      });
    }
    throw new Error(text || "Request failed");
  }

  const data = await res.json();
  if (DEBUG_LOGS) {
    // eslint-disable-next-line no-console
    console.log("[contactService] response", {url, data});
  }
  return data;
}

export function submitContactMessage(payload) {
  return postJson("/submitContactMessage", payload);
}

export function submitWaitlistJoin(payload) {
  return postJson("/submitWaitlistJoin", { ...payload, source: "waitlist" });
}

export function submitNewsletterSubscribe(payload) {
  return postJson("/submitWaitlistJoin", { ...payload, source: "newsletter" });
}
